import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PageSeo from '../seo/PageSeo';
import AdminLayout from '../components/AdminLayout';
import {
    galiaAccentBarSx,
    galiaBodySx,
    galiaHeadlineSx,
    galiaPrimaryButtonSx,
    galiaSecondaryButtonSx,
} from '../theme/galiaUi';

const AdminHome: React.FC = () => (
    <>
        <PageSeo
            title="Admin | Galia Standard Poodles"
            description="Private admin area for Galia Standard Poodles."
            path="/admin"
            noIndex
        />
        <AdminLayout>
            <Box sx={{ maxWidth: 560 }}>
                <Typography component="h1" sx={galiaHeadlineSx}>
                    Admin home
                </Typography>
                <Box sx={galiaAccentBarSx} />
                <Typography sx={{ ...galiaBodySx, mb: 3.5 }}>
                    Invite a family to a planned litter, or review who is already on the list.
                </Typography>
                <Stack spacing={1.5} sx={{ maxWidth: 360 }}>
                    <Button
                        component={RouterLink}
                        to="/admin/invite"
                        variant="contained"
                        sx={{ ...galiaPrimaryButtonSx, width: '100%' }}
                    >
                        Invite owner
                    </Button>
                    <Button
                        component={RouterLink}
                        to="/admin/litters"
                        variant="outlined"
                        sx={{ ...galiaSecondaryButtonSx, width: '100%' }}
                    >
                        Planned litters
                    </Button>
                </Stack>
            </Box>
        </AdminLayout>
    </>
);

export default AdminHome;
